import { render, staticRenderFns } from "./RejectPendingModal.vue?vue&type=template&id=88446632&scoped=true&"
import script from "./RejectPendingModal.vue?vue&type=script&lang=js&"
export * from "./RejectPendingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88446632",
  null
  
)

export default component.exports